var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/lib/index.ts
import axios from "axios";
import Cookies from "js-cookie";

// src/enums/origin.enum.ts
var EOrigin = /* @__PURE__ */ ((EOrigin2) => {
  EOrigin2["MEMBER"] = "MEMBER";
  EOrigin2["CMS"] = "CMS";
  return EOrigin2;
})(EOrigin || {});

// src/enums/local.enum.ts
var ELocal = /* @__PURE__ */ ((ELocal2) => {
  ELocal2["AuthOrigin"] = "authOrigin";
  ELocal2["AccessToken"] = "accessToken";
  return ELocal2;
})(ELocal || {});

// src/utils/constants.ts
var MYACCOUNT_ENDPOINTS = {
  production: "https://myaccount.inspigo.id",
  development: "https://staging-myaccount.inspigo.id",
  local: "http://staging-myaccount.inspigo.id:8076"
};
var ACCOUNT_ENDPOINTS = {
  production: "https://account.inspigo.id",
  development: "https://staging-account.inspigo.id"
};
var MYACCOUNT_ENDPOINT = MYACCOUNT_ENDPOINTS[process.env.ENVIRONMENT !== "production" ? "development" : process.env.ENVIRONMENT];
var ACCOUNT_ENDPOINT = ACCOUNT_ENDPOINTS[process.env.ENVIRONMENT !== "production" ? "development" : process.env.ENVIRONMENT];

// src/lib/index.ts
var DEFAULT_ORIGIN = "MEMBER" /* MEMBER */;
var signIn = (token, origin) => __async(void 0, null, function* () {
  return new Promise(
    (resolve, reject) => __async(void 0, null, function* () {
      var _a;
      try {
        const response = yield axios.post(
          `${ACCOUNT_ENDPOINT}/login`,
          {
            value: token,
            origin,
            grant_type: "token"
          }
        );
        const accessToken = (_a = response.data.data.token) == null ? void 0 : _a.access;
        localStorage.setItem("accessToken" /* AccessToken */, accessToken);
        resolve(response.data.data);
      } catch (error) {
        reject(error);
      }
    })
  );
});
var redirectToSignInPage = (origin) => {
  window.location.replace(
    `${MYACCOUNT_ENDPOINT}/signin?redirect-to=${window.location}&origin=${origin}`
  );
};
var revoke = (..._0) => __async(void 0, [..._0], function* (origin = DEFAULT_ORIGIN) {
  return new Promise((resolve, reject) => __async(void 0, null, function* () {
    try {
      const token = localStorage.getItem("accessToken" /* AccessToken */);
      const refresh = Cookies.get(`refreshToken${origin}`);
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      const response = yield axios.post(
        `${ACCOUNT_ENDPOINT}/login/revoke`,
        { token: refresh, origin },
        config
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  }));
});
var signInWithRefreshToken = (..._0) => __async(void 0, [..._0], function* (origin = DEFAULT_ORIGIN, config) {
  if (!origin) {
    throw new Error(
      `Login with refresh token failed, origin is not defined`
    );
  }
  try {
    const token = Cookies.get(`refreshToken${origin}`);
    const data = yield signIn(token, origin);
    return data;
  } catch (error) {
    if (config.redirectOnFail) {
      redirectToSignInPage(origin);
    } else {
      throw new Error(`Login with refresh token failed, ${error}`);
    }
  }
});
var requiresAuth = (..._0) => __async(void 0, [..._0], function* (origin = DEFAULT_ORIGIN, config) {
  localStorage.setItem("authOrigin" /* AuthOrigin */, origin);
  if (config == null ? void 0 : config.withTokenParam) {
    const tokenFromParam = new URLSearchParams(window.location.search).get("token") || "";
    if (tokenFromParam) {
      const cookieConfig = {
        sameSite: "strict",
        domain: ".inspigo.id"
      };
      Cookies.set(`refreshToken${origin}`, tokenFromParam, cookieConfig);
    }
  }
  if (!Cookies.get(`refreshToken${origin}`)) {
    return redirectToSignInPage(origin);
  }
  yield signInWithRefreshToken(origin, { redirectOnFail: true });
  const loggedInUser = yield getSelfAccount();
  return loggedInUser;
});
var getCookiesRefreshToken = (origin = DEFAULT_ORIGIN) => {
  const refreshToken = Cookies.get(`refreshToken${origin}`);
  if (refreshToken) {
    return refreshToken;
  } else {
    return null;
  }
};
var getSelfAccount = () => __async(void 0, null, function* () {
  return new Promise(
    (resolve, reject) => __async(void 0, null, function* () {
      try {
        const accessToken = localStorage.getItem("accessToken" /* AccessToken */);
        const config = {
          headers: { Authorization: `Bearer ${accessToken}` }
        };
        const { data: responseBody } = yield axios.get(
          `${ACCOUNT_ENDPOINT}/accounts/self`,
          config
        );
        resolve(responseBody.data);
      } catch (error) {
        reject(error);
      }
    })
  );
});
var signOut = (origin = DEFAULT_ORIGIN, config = { redirectToSignInPage: true }) => {
  return new Promise((resolve, reject) => {
    revoke(origin).then((res) => {
      Cookies.remove(`refreshToken${origin}`, {
        domain: ".inspigo.id"
      });
      localStorage.removeItem("accessToken" /* AccessToken */);
      localStorage.removeItem("authOrigin" /* AuthOrigin */);
      if (config == null ? void 0 : config.redirectToSignInPage) {
        redirectToSignInPage(origin);
      }
      resolve(res);
    }).catch((err) => {
      reject(err);
    });
  });
};
export {
  ELocal,
  EOrigin as Origins,
  getCookiesRefreshToken,
  getSelfAccount,
  requiresAuth,
  signInWithRefreshToken,
  signOut
};
